import { createReducer, on } from '@ngrx/store';

import * as LocationActions from './location.actions';
import { initialState } from './location.state';

export const locationReducer = createReducer(
  initialState,

  on(LocationActions.setLocation, (state, { location }) => ({
    ...state,
    location,
  })),

  on(LocationActions.clearLocation, state => ({
    ...state,
    location: null,
  })),

  on(LocationActions.setRegionId, (state, { regionId }) => ({
    ...state,
    location: state.location
      ? { ...state.location, regionId }
      : { city: '', state: '', regionId },
  }))
);
